import { MaxLengthValidatorDirective } from '../../shared/directives/max-length-validator.directive';
import { JstDate } from '../../core/time/business-time';
import { Component, OnInit, ViewChild, inject } from '@angular/core';
import { RouterLink, ActivatedRoute } from '@angular/router';
import { FormsModule, NgForm } from '@angular/forms';
import { PageTitleService } from '../../core/services/page-title.service';
import { MemberService } from '../../core/services/member.service';
import { CounselService } from '../../core/services/counsel.service';
import { FlashService } from '../../core/services/flash.service';
import { FlashMessageComponent } from '../../shared/components/flash-message.component';

@Component({
    selector: 'app-counsel-personal',
    imports: [MaxLengthValidatorDirective, RouterLink, FormsModule, FlashMessageComponent],
    template: `
<div class="animated fadeIn container-fluid">
  <div class="card">
    <div class="card-header">
      <span><i class="fa s-icon-member"></i>&nbsp;初回入力項目</span>
    </div>
    <div class="card-body">
      <!-- 旧版 personal.html:10-12 の card-body 先頭 <flash-message> 相当 -->
      <div class="row"><app-flash-message class="col-md-12"></app-flash-message></div>
      <div class="row">
        <div class="col-md-3 text-md-right">会員氏名：</div>
        <div class="col-md-9 form-group">{{ member?.lastName }}&nbsp;{{ member?.firstName }}</div>
        <div class="col-md-3 text-md-right">区分コース：</div>
        <div class="col-md-9 form-group">{{ member?.studioPlan?.name }}</div>
      </div>
      <hr />
    </div>
    <div class="card-body">
      <div class="col-md-12">
        <form novalidate name="personalEditForm" #personalEditForm="ngForm">
          <div class="row">
            <div class="col-md-12">
              <div class="form-group">
                <div class="col-md-4 row align-items-end">
                  <label class="col-form-label w-100">身長（cm）</label>
                  <select class="form-control col-8" [(ngModel)]="form.heightInteger" name="heightInteger" required>
                    <option [ngValue]="null">--</option>
                    @for (n of range(120, 200); track n) { <option [ngValue]="n">{{ n }}</option> }
                  </select>
                  <div><span>&nbsp;.&nbsp;</span></div>
                  <select class="form-control col-3" [(ngModel)]="form.heightDecimal" name="heightDecimal">
                    <option [ngValue]="null">--</option>
                    @for (n of range(0, 9); track n) { <option [ngValue]="n">{{ n }}</option> }
                  </select>
                </div>
              </div>
              <div class="form-group row">
                <div class="col-md-12">
                  <label class="col-form-label">ダイエット実施歴</label>
                  <textarea type="text" class="form-control" rows="5" [(ngModel)]="form.dietNote" name="dietNote" placeholder="フリーワード入力（512文字以内）" sfMaxLength="512"></textarea>
                </div>
              </div>
              <div class="form-group row">
                <div class="col-md-12">
                  <label class="col-form-label">持病</label>
                  <input type="text" class="form-control" [(ngModel)]="form.chronicIllness" name="chronicIllness" placeholder="フリーワード入力（255文字以内）" sfMaxLength="255">
                </div>
              </div>
              <br /><br />
              <strong>生活習慣</strong>
              <hr />
              <div class="form-group row">
                <div class="col-md-12">
                  <label class="col-form-label">職業</label>
                  <input type="text" class="form-control" [(ngModel)]="form.profession" name="profession" placeholder="フリーワード入力（255文字以内）" sfMaxLength="255">
                </div>
              </div>
              <div class="form-group row">
                <div class="col-md-12">
                  <label class="col-form-label">1日3食取れているか？</label>
                  <div class="custom-control custom-radio">
                    <div class="custom-control custom-radio custom-control-inline">
                      <input type="radio" id="is_taking_three_meals_1" class="custom-control-input" [(ngModel)]="form.isTakingThreeMeals" name="isTakingThreeMeals" value="1">
                      <label class="custom-control-label" for="is_taking_three_meals_1">取れている</label>
                    </div>
                    <div class="custom-control custom-radio custom-control-inline">
                      <input type="radio" id="is_taking_three_meals_0" class="custom-control-input" [(ngModel)]="form.isTakingThreeMeals" name="isTakingThreeMeals" value="0">
                      <label class="custom-control-label" for="is_taking_three_meals_0">取れていない</label>
                    </div>
                  </div>
                </div>
              </div>
              <div class="form-group row">
                <div class="col-md-12">
                  <label class="col-form-label">間食をしているか？</label>
                  <div class="custom-control custom-radio">
                    <div class="custom-control custom-radio custom-control-inline">
                      <input type="radio" id="is_Snacking_0" class="custom-control-input" [(ngModel)]="form.isSnacking" name="isSnacking" value="0">
                      <label class="custom-control-label" for="is_Snacking_0">していない</label>
                    </div>
                    <div class="custom-control custom-radio custom-control-inline">
                      <input type="radio" id="is_Snacking_1" class="custom-control-input" [(ngModel)]="form.isSnacking" name="isSnacking" value="1">
                      <label class="custom-control-label" for="is_Snacking_1">している</label>
                    </div>
                  </div>
                </div>
              </div>
              <div class="form-group row">
                <div class="col-md-4">
                  <label class="col-form-label">起床時間</label>
                  <input type="time" class="form-control" [(ngModel)]="form.wakeTime" name="wakeTime" value="hh:mm">
                </div>
              </div>
              <div class="form-group row">
                <div class="col-md-4">
                  <label class="col-form-label">就寝時間</label>
                  <input type="time" class="form-control" [(ngModel)]="form.bedTime" name="bedTime" value="hh:mm">
                </div>
              </div>
              <div class="form-group row">
                <div class="col-md-12">
                  <label class="col-form-label">喫煙しているか？</label>
                  <div class="custom-control custom-radio">
                    <div class="custom-control custom-radio custom-control-inline">
                      <input type="radio" id="is_smoking_0" class="custom-control-input" [(ngModel)]="form.isSmoking" name="isSmoking" value="0">
                      <label class="custom-control-label" for="is_smoking_0">していない</label>
                    </div>
                    <div class="custom-control custom-radio custom-control-inline">
                      <input type="radio" id="is_smoking_1" class="custom-control-input" [(ngModel)]="form.isSmoking" name="isSmoking" value="1">
                      <label class="custom-control-label" for="is_smoking_1">している</label>
                    </div>
                  </div>
                </div>
              </div>
              <div class="form-group row">
                <div class="col-md-12">
                  <label class="col-form-label">飲酒しているか？</label>
                  <div class="custom-control custom-radio">
                    <div class="custom-control custom-radio custom-control-inline">
                      <input type="radio" id="is_drinking_0" class="custom-control-input" [(ngModel)]="form.isDrinking" name="isDrinking" value="0">
                      <label class="custom-control-label" for="is_drinking_0">していない</label>
                    </div>
                    <div class="custom-control custom-radio custom-control-inline">
                      <input type="radio" id="is_drinking_1" class="custom-control-input" [(ngModel)]="form.isDrinking" name="isDrinking" value="1">
                      <label class="custom-control-label" for="is_drinking_1">している</label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
        <div class="row">
          <div class="col-md-12 text-right">
            <a [routerLink]="['/counsel', memberId]" class="btn bg-close text-white"><i class="fa s-icon-cancel"></i>&nbsp;閉じる</a>
            <button type="button" (click)="save()" class="btn btn-success" [disabled]="saving || personalEditForm.invalid"><i class="fa s-icon-save"></i>&nbsp;保存</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
  `
})
export class CounselPersonalComponent implements OnInit {
  @ViewChild('personalEditForm') personalEditForm?: NgForm;
  private pageTitleService = inject(PageTitleService);
  private memberService = inject(MemberService);
  private counselService = inject(CounselService);
  private route = inject(ActivatedRoute);
  private flash = inject(FlashService);

  memberId!: number;
  member: any = null;
  form: any = {};
  loading = false;
  saving = false;

  range(min: number, max: number): number[] {
    const arr = [];
    for (let i = min; i <= max; i++) arr.push(i);
    return arr;
  }

  async ngOnInit(): Promise<void> {
    this.pageTitleService.set('会員管理', 's-icon-members');
    this.memberId = +this.route.snapshot.params['memberId'];
    await this.load();
  }

  private async load(): Promise<void> {
    this.loading = true;
    try {
      [this.member, this.form] = await Promise.all([
        this.memberService.getOne(this.memberId),
        this.memberService.getPersonal(this.memberId),
      ]);
      if (!this.form) this.form = { memberId: this.memberId };
      if (this.form.height) {
        const s = String(this.form.height).split('.');
        this.form.heightInteger = Number(s[0]);
        this.form.heightDecimal = Number(s[1] ?? 0);
      }
      for (const key of ['isTakingThreeMeals', 'isSnacking', 'isSmoking', 'isDrinking']) {
        if (this.form[key] !== null && this.form[key] !== undefined) {
          this.form[key] = String(this.form[key]);
        }
      }
      this.form.wakeTime = this.toInputTime(this.form.wakeTime);
      this.form.bedTime = this.toInputTime(this.form.bedTime);
    } finally {
      this.loading = false;
    }
  }

  private toInputTime(value: any): any {
    if (!value || typeof value !== 'string') return value;
    const match = value.match(/^(\d{1,2}):(\d{2})/);
    return match ? `${match[1].padStart(2, '0')}:${match[2]}` : value;
  }

  private toApiTime(value: any): any {
    if (!value) return value;
    if (typeof value === 'string') {
      const match = value.match(/^(\d{1,2}):(\d{2})(?::(\d{2}))?/);
      if (match) {
        return `${match[1].padStart(2, '0')}:${match[2]}:${match[3] ?? '00'}`;
      }
      return value;
    }
    const date = new JstDate(value);
    if (Number.isNaN(date.getTime())) return value;
    return [date.getHours(), date.getMinutes(), date.getSeconds()]
      .map(part => String(part).padStart(2, '0'))
      .join(':');
  }

  async save(): Promise<void> {
    if (this.saving || this.personalEditForm?.invalid) return;
    this.saving = true;
    try {
      const json = { ...this.form, memberId: this.memberId };
      if (this.form.heightInteger != null) {
        json.height = parseFloat(String(this.form.heightInteger) + '.' + (this.form.heightDecimal ?? 0));
      }
      json.wakeTime = this.toApiTime(json.wakeTime);
      json.bedTime = this.toApiTime(json.bedTime);
      delete json.heightInteger;
      delete json.heightDecimal;
      delete json.createdAt;
      delete json.updatedAt;
      await this.counselService.upsertPersonal(json);
      // 旧版 personal.js:64-68: Flash・先頭へscroll・state reload
      this.flash.create('success', 'パーソナルデータを更新しました');
      window.scrollTo({ top: 0 });
      await this.load();
    } finally {
      this.saving = false;
    }
  }
}
